import * as React from 'react'

const SvgComponent = props => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 18' {...props}>
    <path d='M1 0h18c.55 0 1 .45 1 1v16c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1V1c0-.55.45-1 1-1Zm17 4.24-7.93 7.1L2 4.22V16h16V4.24ZM2.51 2l7.55 6.66L17.5 2H2.51Z' />
  </svg>
)

export default SvgComponent
